import { createFileRoute, redirect } from '@tanstack/react-router'
import { USERS_TABS } from '~/components/routes/users/tabs'
import { resolveMissingPermissions, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/users/')({
  staticData: {
    permission: { any: USERS_TABS.map((tab) => tab.permission) },
  },
  beforeLoad: ({ context }) => {
    const first = USERS_TABS.find(
      (tab) => resolveMissingPermissions(context.ability, tab.permission).length === 0,
    )
    throw redirect({ to: first?.to ?? USERS_TABS[0].to })
  },
})
withRoutePermissions(Route)
